import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./Button.css"

import { useRaiseError } from "@app/store/actions/errorActions"
import { elementWasSelected } from "@app/utils/accessibility"
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons/faCircleNotch"

const Button = ({ children, style, onClick, fillWidth, className, disabled, isLoading, cssStyle, disabledReason, ariaLabel, handleKeyDown }) => {
	const raiseError = useRaiseError()

	const handleClick = () => {
		disabled || isLoading
			? () => {
					if (disabled && disabledReason) {
						raiseError(new Error(disabledReason))
					}
					return
				}
			: onClick?.()
	}

	return (
		<button
			className={"px-5 py-3 rounded-2 text-center flex flex-center button " + style + " " + className + " " + (disabled ? " disabled" : "")}
			onClick={handleClick}
			type="button"
			onKeyDown={e => {
				if (!elementWasSelected(e)) return
				handleKeyDown ? handleKeyDown(e) : handleClick()
			}}
			style={{
				display: "inline-flex",
				width: fillWidth ? "100%" : "auto",
				...(cssStyle || {}),
			}}
			aria-disabled={disabled || isLoading}
			aria-label={ariaLabel}
		>
			{disabled && disabledReason ? <span className="sr-only">{disabledReason}</span> : null}
			{!isLoading ? (
				<span>{children}</span>
			) : (
				<div>
					<FontAwesomeIcon icon={faCircleNotch} className="fa-spin mr-2" /> {children}
				</div>
			)}
		</button>
	)
}

export default Button
